const extrasTariffsCodeWithoutOverridingPriceAvailable = [
  'FF_REACC_GBP',
  'MD_REACC_GBP',
  'FF_REACC_EUR',
  'MD_REACC_EUR',
  'FF_REACC_USD',
  'MD_REACC_USD',
  'ANIMAL_LILLE'
];

const formatExtras = (values, currency) => {
  const regularPassengerIds = values.extras.map((extra) => extra.passengerId).filter(Boolean);
  const luggagePassengerIds =
    values.luggageExtras?.formPayload?.add?.flatMap((addItem) => addItem.items.map((item) => item.passengerId)).filter(Boolean) || [];

  const uniquePassengerIds = [...new Set([...regularPassengerIds, ...luggagePassengerIds])];

  const allPassengerIds = uniquePassengerIds.sort((a, b) => {
    const indexA = values.passengers.findIndex((p) => p.id === a);
    const indexB = values.passengers.findIndex((p) => p.id === b);
    return indexA - indexB;
  });

  const passengersMap = new Map(
    allPassengerIds.map((oldPassengerId, index) => {
      const bookingPassenger = values.passengers.find((p) => p.id === oldPassengerId);

      return [
        oldPassengerId,
        {
          id: `passenger_${index + 1}`,
          type: bookingPassenger.type,
          firstName: bookingPassenger.firstName,
          lastName: bookingPassenger.lastName,
          email: bookingPassenger.email || values.email,
          phoneNumber: bookingPassenger.phoneNumber || values.phone
        }
      ];
    })
  );

  const passengers = Array.from(passengersMap.values());

  const regularExtrasSegments = values.extras.map((extra) => ({
    origin: extra.origin,
    destination: extra.destination,
    startValidityDate: extra.date,
    items: Array(Number(extra.quantity))
      .fill()
      .map(() => ({
        passengerId: passengersMap.get(extra.passengerId).id,
        tariffCode: extra.extraName,
        ...(!extrasTariffsCodeWithoutOverridingPriceAvailable.includes(extra.extraName) && { price: Number(extra.price) })
      }))
  }));

  let luggageExtrasSegments = [];
  if (values.luggageExtras?.formPayload?.add && values.luggageExtras?.transformedLuggageExtras) {
    const { formPayload, transformedLuggageExtras } = values.luggageExtras;

    formPayload.add.forEach((addItem) => {
      const outboundItems = addItem.items.filter((item) => item.direction === 'outbound');
      const inboundItems = addItem.items.filter((item) => item.direction === 'inbound');

      if (outboundItems.length > 0) {
        const itemsByMetadata = new Map();

        outboundItems.forEach((item) => {
          const metadata = (transformedLuggageExtras.outbound || []).find(
            (e) => e.id === addItem.id && e.paxSegments?.some((ps) => ps.passengerId === item.passengerId)
          );

          if (metadata) {
            const key = metadata.serviceIdentifier;
            if (!itemsByMetadata.has(key)) {
              itemsByMetadata.set(key, { metadata, items: [] });
            }
            itemsByMetadata.get(key).items.push(item);
          }
        });

        itemsByMetadata.forEach(({ metadata, items }) => {
          luggageExtrasSegments.push({
            direction: 'outbound',
            origin: metadata.origin,
            destination: metadata.destination,
            startValidityDate: metadata.startValidityDate,
            serviceName: metadata.serviceName,
            serviceIdentifier: metadata.serviceIdentifier,
            items: items.map((item) => ({
              passengerId: passengersMap.get(item.passengerId).id,
              tariffCode: addItem.id
            }))
          });
        });
      }

      if (inboundItems.length > 0) {
        const itemsByMetadata = new Map();

        inboundItems.forEach((item) => {
          const metadata = (transformedLuggageExtras.inbound || []).find(
            (e) => e.id === addItem.id && e.paxSegments?.some((ps) => ps.passengerId === item.passengerId)
          );

          if (metadata) {
            const key = metadata.serviceIdentifier;
            if (!itemsByMetadata.has(key)) {
              itemsByMetadata.set(key, { metadata, items: [] });
            }
            itemsByMetadata.get(key).items.push(item);
          }
        });

        itemsByMetadata.forEach(({ metadata, items }) => {
          luggageExtrasSegments.push({
            direction: 'inbound',
            origin: metadata.origin,
            destination: metadata.destination,
            startValidityDate: metadata.startValidityDate,
            serviceName: metadata.serviceName,
            serviceIdentifier: metadata.serviceIdentifier,
            items: items.map((item) => ({
              passengerId: passengersMap.get(item.passengerId).id,
              tariffCode: addItem.id
            }))
          });
        });
      }
    });
  }

  return {
    currency,
    segments: [...regularExtrasSegments, ...luggageExtrasSegments],
    passengers,
    customer: {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phoneNumber: values.phone
    },
    associatedBookingReference: values.associatedBookingReference
  };
};

export default formatExtras;
